var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auth-page md-layout md-alignment-center-center" },
    [
      _c(
        "md-card",
        { staticClass: "auth-page__card" },
        [
          _c("md-card-header", [
            _c("div", { staticClass: "text_xl_large" }, [
              _vm._v(_vm._s(_vm.i18n.lbl_almost_done()))
            ])
          ]),
          _vm._v(" "),
          _c("md-card-content", [
            _c("p", { staticClass: "text_small" }, [
              _vm._v(
                _vm._s(_vm.i18n.lbl_confirmation_sent({ mail: _vm.email }))
              )
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "text_small" }, [
              _vm._v(_vm._s(_vm.i18n.lbl_check_spam()))
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "btn-wrap margin-top" },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "btn md-primary",
                    attrs: { disabled: _vm.isButtonDisabled },
                    on: { click: _vm.requestNew }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.i18n.lbl_request_new_email()) +
                        "\n        "
                    )
                  ]
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37aa3e91", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37aa3e91","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/auth/ConfirmEmail.vue
// module id = Sf6N
// module chunks = 1